import DivComponent from "../components/div";
import LiComponent from "../components/li";
import ProductCardTileComponent from "../components/product-card-tile";
// import UlComponent from "../components/ul";
import {getProductData} from "../parsing/product";
import {RenderPosition, remove, render} from "../utils/render";
import CommentsCountController from "./comments";
import CommerceController from "./commerce";
import CommerceControllerLikeMP from "./commerce-like-mp";
import FavoritesController from "./favorites";
// import ImagesController from "./image";
import ImagesHvrController from "./image-hvr";
// import HvrSlider from "./img-slider";
import LabelsController from "./labels";
import NotInStokeController from "./not-in-stock";
import PriceController from "./price";
import PropertiesController from "./properties";
import RatingController from "./rating";
import StockController from "./stock";

export default class ItemsController {
  constructor({items = [], shopInfoData, page = ``}) {
    this._items = items;
    this._shopInfoData = shopInfoData;
    this._className = `items`;
    this._isLikeMP = true;
    this._page = page;
  }

  render(container) {
    Object.values(this._items).forEach((productData) => {
      const product = getProductData(productData);

      const liItemComponent = new LiComponent({
        className: `${this._className}__itemWrap`,
      });
      render(container, liItemComponent.getElement(), RenderPosition.BEFOREEND);

      const productCardComponent = new ProductCardTileComponent({
        className: this._className,
        data: product,
        isLikeMP: this._isLikeMP,
      });

      new ImagesHvrController({
        images: product.images,
        title: product.title,
      }).render(productCardComponent.getElement().querySelector(`.${this._className}__itemImage`));

      const ratingWrapComponent = new DivComponent(`${this._className}__itemRatingWrap`);
      render(productCardComponent.getElement(), ratingWrapComponent.getElement(), RenderPosition.BEFOREEND);

      new RatingController({
        className: this._className,
        rating: product.rating,
        onClickHandler: () => {},
      }).render(ratingWrapComponent.getElement());

      new CommentsCountController({
        className: this._className,
        count: product.commentCount,
        isShowEnding: false,
        onClickHandler: () => {},
        // onClickHandler: () => window.open(`/${product.link}`, `_blank`),
      }).render(ratingWrapComponent.getElement());

      const propertyWrapComponent = new DivComponent(`${this._className}__itemPropertyWrap`);
      render(productCardComponent.getElement(), propertyWrapComponent.getElement(), RenderPosition.BEFOREEND);

      new PropertiesController({
        properties: product.properties,
      }).render(propertyWrapComponent.getElement());

      if (product.isActive) {
        const actionWrapComponent = new DivComponent(`${this._className}__itemActionWrap`);
        render(productCardComponent.getElement(), actionWrapComponent.getElement(), RenderPosition.BEFOREEND);

        new PriceController({
          className: this._className,
          price: product.price,
          oldPrice: product.oldPrice,
        }).render(actionWrapComponent.getElement());

        if (this._isLikeMP) {
          new CommerceControllerLikeMP({
            container: productCardComponent.getElement(),
            className: this._className,
            likeMP: true,
            itemId: product.itemId,
            count: product.cartCount,
            // deliveryDate: product.deliveryDate,
            deliveryText: product.deliveryText,
            deliveryNote: product.deliveryNote,
            // item_date_button:"Сегодня"
            // item_date_note:"В наличии 1 шт."
          }).render();
        } else {
          new CommerceController({
            container: actionWrapComponent.getElement(),
            className: this._className,
            likeMP: true,
            itemId: product.itemId,
            count: product.cartCount,
          }).render();
        }

        if (!this._isLikeMP) {
          new StockController({
            className: this._className,
            // isLikeMP: this._isLikeMP,
            cityP: this._shopInfoData.town_p,
            stockCount: product.stockCount,
            deliveryDate: product.deliveryDate,
          }).render(productCardComponent.getElement());
        }
      } else {
        new NotInStokeController().render(productCardComponent.getElement());
      }

      new LabelsController({
        className: this._className,
        labels: product.labels,
        itemId: product.itemId,
      }).render(productCardComponent.getElement());

      new FavoritesController({
        className: this._className,
        itemId: product.itemId,
        isCheck: product.isFavorite,
        onChangeData: () => {
          if (this._page === `favorites`) {
            // для страницы Избранных
            remove(liItemComponent);
          }
        }
      }).render(productCardComponent.getElement().querySelector(`.${this._className}__infoWrap`));
      // }).render(productCardComponent.getElement());

      render(liItemComponent.getElement(), productCardComponent.getElement(), RenderPosition.BEFOREEND);

      // eslint-disable-next-line no-new
      // new HvrSlider(`.images`);
    });
  }
}
